import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["statusField"]

  connect() {
    // Initialize collapse element
    if (this.hasStatusFieldTarget) {
      // Listen for Bootstrap collapse events
      const collapseElement = document.getElementById('advancedSearch')
      if (collapseElement) {
        collapseElement.addEventListener('shown.bs.collapse', this.shown.bind(this))
        collapseElement.addEventListener('hidden.bs.collapse', this.hidden.bind(this))
      }
    }
  }

  shown() {
    if (this.hasStatusFieldTarget) {
      this.statusFieldTarget.value = "true"
    }
  }

  hidden() {
    if (this.hasStatusFieldTarget) {
      this.statusFieldTarget.value = ""
    }
  }
}